// extracted by mini-css-extract-plugin
export default {"iconStroke":"styles_iconStroke__L8KqR","iconFill":"styles_iconFill__gfJGp","invertedStroke":"styles_invertedStroke__tEbc9","invertedFill":"styles_invertedFill__sE3H3"};